import { jsxs as m, jsx as s } from "react/jsx-runtime";
import { c as o } from "./index-65016bfa.mjs";
import { forwardRef as f } from "react";
import { styled as r, css as i } from "styled-components";
import "@fcamna/shared-component-foundations";
import { u as b } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { Link as w } from "./link.js";
import "./_commonjsHelpers-92157f1b.mjs";
import "./Aria-f5e019e2.mjs";
import "./icon.js";
import "@fcamna/shared-icons";
const C = r.div`
  &.TextDisclosure__wrapper {
    ${({
  theme: {
    components: { textDisclosure: e },
    componentStyles: c
  }
}) => i(e.TextDisclosureWrapper, c)};
  }
`, L = r.div`
  &.TextDisclosure__items {
    ${({
  theme: {
    components: { textDisclosure: e }
  }
}) => i(e.TextDisclosureItems)};
  }
`, W = r.div`
  &.TextDisclosure__title {
    ${({
  theme: {
    components: { textDisclosure: e }
  }
}) => i(e.TextDisclosureTitle)};
  }
`, g = r.div`
  &.TextDisclosure__content-wrapper {
    ${({
  theme: {
    components: { textDisclosure: e }
  }
}) => i(e.TextDisclosureContentWrapper)};
  }
`, B = r.div`
  &.TextDisclosure__bullet {
    ${({
  theme: {
    components: { textDisclosure: e }
  }
}) => i(e.TextDisclosureBullet)};
  }
`, I = r.div`
  &.TextDisclosure__content-container {
    ${({
  theme: {
    components: { textDisclosure: e }
  }
}) => i(e.TextDisclosureContentContainer)};
  }
`, j = r.div`
  &.TextDisclosure__global {
    ${({
  theme: {
    components: { textDisclosure: e }
  }
}) => i(e.GlobalDisclosureWrapper)};
  }
`, J = f(
  ({
    titleProp: e = {
      title: "Disclosure(s)",
      headingLevel: "h2"
    },
    disclosureItems: c = [],
    globalDisclosureContent: u,
    className: t = "",
    returnToLinkTitle: T = "Return to content",
    id: a,
    disclosurePrefix: x = "Disclosure",
    ..._
  }, h) => {
    var p;
    const d = b({ label: "Text Disclosure" });
    return /* @__PURE__ */ m(
      C,
      {
        ref: h,
        ..._,
        id: a,
        className: o([t, "TextDisclosure__wrapper"]),
        ...d,
        children: [
          !!((p = e.title) != null && p.trim()) && /* @__PURE__ */ s(
            W,
            {
              className: o([t, "TextDisclosure__title"]),
              as: e.headingLevel,
              children: e.title
            }
          ),
          !!u && /* @__PURE__ */ s(
            j,
            {
              tabIndex: 0,
              className: o([t, "TextDisclosure__global"]),
              children: u
            }
          ),
          c.length > 0 && /* @__PURE__ */ s(L, { className: o([t, "TextDisclosure__items"]), children: c.map(({ text: $, disclosureNumber: n, returnToLinkTitle: D, ...v }, l) => /* @__PURE__ */ m(
            g,
            {
              className: o([t, "TextDisclosure__content-wrapper"]),
              id: `${a}-item-${n || l + 1}`,
              tabIndex: 0,
              "data-disclosure-content-number": n || l + 1,
              children: [
                /* @__PURE__ */ s(B, { className: o([t, "TextDisclosure__bullet"]), children: `${n || l + 1})` }),
                /* @__PURE__ */ m(I, { className: o([t, "TextDisclosure__content-container"]), children: [
                  /* @__PURE__ */ s("div", { children: $ }),
                  /* @__PURE__ */ s("div", { children: /* @__PURE__ */ s(
                    w,
                    {
                      ...v,
                      size: "xsmall",
                      isDisclosureLink: !0,
                      "data-return-disclosure-number": n || l + 1,
                      children: D || `${T}, ${x} ${n || l + 1}`
                    }
                  ) })
                ] })
              ]
            },
            l
          )) })
        ]
      }
    );
  }
);
export {
  J as TextDisclosure
};
